module.exports = __webpack_public_path__ + "img/sunset-4.d7cc9470.jpg";